import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ffe4a39a"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./styles.scss?vue&type=custom&index=0&blockType=styles&issuerPath=%2Fbuilds%2Ftsno%2Ffrechdax%2Ffrechdax-abdl%2Ffrechdax-abdl-italy%2Fweb%2Fwebapp%2Fsrc%2Fcomponents%2Fparty-circles%2Findex.vue&scoped=true&lang=scss&external"
if (typeof block0 === 'function') block0(component)
import block1 from "@/locales/global.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuilds%2Ftsno%2Ffrechdax%2Ffrechdax-abdl%2Ffrechdax-abdl-italy%2Fweb%2Fwebapp%2Fsrc%2Fcomponents%2Fparty-circles%2Findex.vue&external"
if (typeof block1 === 'function') block1(component)

export default component.exports